import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
} from '@nexelem/deprecated-theme';
import { showDevtools, useDevtoolsStore } from './useDevtoolsStore';
import { useCallback, useState } from 'react';
import { ClientId } from '@nexelem/config';
import { Button } from '@nexelem/components';

export const DeveloperTools = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const setClient = useDevtoolsStore((state) => state.setClient);
  const client = useDevtoolsStore((state) => state.clientId);

  const handleChangeClient = (event: SelectChangeEvent) => {
    setClient(event.target.value as ClientId);
  };

  const onShowQueryDevtools = useCallback(() => {
    // @ts-expect-error window
    if (window.toggleDevtools) {
      // @ts-expect-error window
      window.toggleDevtools();
      handleClose();
    }
  }, []);

  if (!showDevtools) {
    return null;
  }

  return (
    <>
      <div
        className="fixed top-0 left-[50%] z-1205 cursor-pointer rounded-b-xs bg-surface-status-green-lighter p-1 text-s11-sb hover:bg-surface-status-green-darker"
        onClick={handleOpen}
      >
        Open DevTools
      </div>
      <Modal open={open} onClose={handleClose}>
        <div className="absolute top-[50%] left-[50%] flex w-xs translate-[-50%] flex-col gap-4 rounded-xs border border-border-container bg-text-primary-inverse p-4">
          <h1 className="text-t20-sb">Developer Tools</h1>

          <Button variant="contained" onClick={onShowQueryDevtools}>
            Tanstack DevTools
          </Button>

          <Divider />

          <FormControl fullWidth>
            <InputLabel id="client">Client</InputLabel>
            <Select id="client-select" label="Client" labelId="client" value={client} onChange={handleChangeClient}>
              {Object.values(ClientId).map((id) => (
                <MenuItem key={id} value={id}>
                  {id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Save
          </Button>
        </div>
      </Modal>
    </>
  );
};
